<template>
  <div class="new-vdp-toggle">
    <div class="header">
      <span>
        New VDP Experience Enabled
      </span>
      <AcvToggleSwitch
        id="new-vdp-toggle"
        v-model="vdp3Preference"
        label=""
        :hide-label="true"
        round
        class="marketplace-new-vdp__toggle"
      />
    </div>
    <p>
      {{ descriptionContent.header }}
    </p>
    <p v-if="descriptionContent.body">
      {{ descriptionContent.body }}
    </p>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import {
  AcvToggleSwitch,
} from '@acv/shared-vuejs';

import { mapState } from 'vuex';
import usePandaVdpVersionToggle from '@/composables/marketplace/panda/usePandaVdpVersionToggle';

export default defineComponent({
  name: 'AcvMarketplaceNewVdpToggle',
  components: {
    AcvToggleSwitch,
  },
  setup() {
    const { toggleVdpVersionPreference } = usePandaVdpVersionToggle();
    return { toggleVdpVersionPreference };
  },
  computed: {
    ...mapState({
      vdpVersionPreference: (state) => state.pandaMfe.vdpVersionPreference,
    }),
    descriptionContent() {
      return this.vdpVersionPreference
        ? {
          header: "You're using the new VDP experience.",
          body: 'Switch back to Classic anytime using this toggle.',
        }
        : {
          header: 'Experience the New VDP with a cleaner, more streamlined layout and new features designed to help you make faster, more informed decisions.',
        };
    },
    vdp3Preference: {
      get() {
        return this.vdpVersionPreference;
      },
      set() {
        this.toggleVdpVersionPreference();
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.new-vdp-toggle {
    display: flex;
    flex-direction: column;
    padding : 16px 19px;
    width: 350px;
    border-radius: 12px;
    border: 1px solid #E8E9EB;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      span {
        color: #0E0E0F;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        letter-spacing: 0.15px;
      }
    }

    p {
      color: #55575C;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.1px;
      margin-bottom: 0;
    }
}
</style>
